import {FC, lazy} from 'react'
import {AnimatedRoutes, RouteTransition} from 'components/HOCs'
import {PrivateRoutes} from './PrivateRoutes'
import {PublicRoutes} from './PublicRoutes'

const NoMatchPage = lazy(() =>
  import('../PageNotFound').catch(() => import('../PageNotFound')),
)

interface Props {
  location?: {
    state: {
      status: string
    }
  }
}
export const AllRoutes: FC<Props> = () => {
  return (
    <AnimatedRoutes>
      {PublicRoutes()}
      {PrivateRoutes()}
      <RouteTransition path="*">
        <NoMatchPage />
      </RouteTransition>
    </AnimatedRoutes>
  )
}
